import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Paper, Slide, Link } from '@mui/material';
import CookieIcon from '@mui/icons-material/Cookie';

export default function CookieBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const localConsent = localStorage.getItem('cookieConsent');
    const cookieConsent = document.cookie.split('; ').find(row => row.startsWith('cookieConsent='))?.split('=')[1];
    
    if (!localConsent && !cookieConsent) {
      setOpen(true);
    } else if (cookieConsent && !localConsent) {
      localStorage.setItem('cookieConsent', cookieConsent);
    }
  }, []);

  const setConsent = (level) => {
    localStorage.setItem('cookieConsent', level);
    document.cookie = `cookieConsent=${level}; max-age=31536000; path=/`;
    setOpen(false);
  };

  const handleAcceptAll = () => setConsent('all');
  const handleAcceptNecessary = () => setConsent('necessary');

  if (!open) return null;

  return (
    <Slide direction="up" in={open} mountOnEnter unmountOnExit>
      <Paper 
        elevation={24} 
        sx={{ 
          position: 'fixed', 
          bottom: 24, 
          left: 0, 
          right: 0, 
          margin: '0 auto',
          width: { xs: 'calc(100% - 32px)', sm: '80%', md: 800 }, 
          maxWidth: 800,
          p: 3, 
          borderRadius: 4, 
          bgcolor: 'rgba(255, 255, 255, 0.98)', 
          backdropFilter: 'blur(10px)', 
          border: '1px solid #e2e8f0', 
          zIndex: 9999,
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'flex-start', md: 'center' },
          gap: 3
        }}
      >
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', flex: 1 }}>
          <Box sx={{ p: 1.5, bgcolor: '#f0fdf4', borderRadius: 3, color: '#16a34a' }}>
            <CookieIcon fontSize="medium" />
          </Box>
          <Box>
            <Typography variant="subtitle1" fontWeight={800} color="#1e293b" gutterBottom>
              Wir respektieren Ihre Privatsphäre
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>
              Diese Webseite verwendet technisch notwendige Cookies, um die grundlegende Funktionalität (z.B. Login) bereitzustellen. Zusätzliche Cookies zur Analyse (Local Storage) werden nur mit Ihrer Zustimmung gemäß TTDSG gesetzt.
              <br />
              Weitere Informationen finden Sie in unserer <Link href="#" sx={{ fontWeight: 600, color: 'primary.main' }}>Datenschutzerklärung</Link>.
            </Typography>
          </Box>
        </Box>
        
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 1.5, width: { xs: '100%', md: 'auto' } }}>
          <Button 
            variant="outlined" 
            fullWidth 
            onClick={handleAcceptNecessary}
            sx={{ borderRadius: 2, fontWeight: 700, whiteSpace: 'nowrap', py: 1 }}
          >
            Nur Notwendige
          </Button>
          <Button 
            variant="contained" 
            fullWidth 
            onClick={handleAcceptAll}
            sx={{ borderRadius: 2, fontWeight: 700, whiteSpace: 'nowrap', py: 1, boxShadow: 'none' }}
          >
            Alle Akzeptieren
          </Button>
        </Box>
      </Paper>
    </Slide>
  );
}
